import { Link } from "react-router-dom";
import { ArrowRight, Truck, ShieldCheck, CreditCard } from "lucide-react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { CartDrawer } from "./CartDrawer";
import { CATEGORIES } from "../data/categories";
import { countByCategory } from "../data/products";

const TRUST = [
  { icon: Truck, text: "Envío gratis desde $200.000" },
  { icon: ShieldCheck, text: "Impreso en MDF de alta calidad" },
  { icon: CreditCard, text: "Pago seguro con Bold" },
];

export const CategoriesPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans antialiased">
      <Navbar />
      <CartDrawer />

      <main
        data-testid="categories-page"
        className="pt-24 md:pt-28 pb-16 md:pb-24"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="max-w-2xl mb-8 md:mb-10">
            <span className="block text-xs uppercase tracking-[0.22em] text-[#E85A3C] mb-3">
              Categorías
            </span>
            <h1
              data-testid="categories-heading"
              className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900 leading-[1.05]"
            >
              12 mundos para
              <br />
              <span className="italic">tus paredes</span>.
            </h1>
            <p className="mt-4 text-base text-slate-600 leading-relaxed">
              Elige tu estilo y descubre los cuadros que van con tu espacio.
              Pasa el cursor para verlos puestos en una pared real.
            </p>
          </div>

          {/* Trust strip */}
          <div
            data-testid="categories-trust-strip"
            className="flex flex-wrap items-center gap-x-8 gap-y-2 border-y border-slate-200 py-3 mb-10 md:mb-14"
          >
            {TRUST.map(({ icon: Icon, text }) => (
              <span
                key={text}
                className="inline-flex items-center gap-2 text-xs md:text-sm text-slate-600"
              >
                <Icon className="h-4 w-4 text-[#E85A3C]" strokeWidth={1.75} />
                {text}
              </span>
            ))}
          </div>

          {/* Grid de categorías */}
          <div
            data-testid="categories-grid"
            className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6"
          >
            {CATEGORIES.map((c) => {
              const count = countByCategory(c.slug);
              return (
                <Link
                  key={c.slug}
                  to={`/categoria/${c.slug}`}
                  data-testid={`category-card-${c.slug}`}
                  className="group relative aspect-[4/5] rounded-2xl overflow-hidden bg-slate-200 shadow-sm hover:shadow-xl transition-shadow duration-300"
                >
                  {/* Obra */}
                  <img
                    src={c.image}
                    alt={c.name}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover transition-opacity duration-500 group-hover:opacity-0"
                  />
                  {/* En pared (hover) */}
                  <img
                    src={c.wallImage}
                    alt={`${c.name} en pared`}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-500 group-hover:opacity-100"
                  />
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent" />

                  {/* Conteo */}
                  <span className="absolute top-3 right-3 inline-flex items-center bg-white/85 backdrop-blur-sm text-slate-800 text-[11px] font-medium px-2.5 py-1 rounded-full">
                    {count} diseños
                  </span>

                  {/* Info */}
                  <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                    <h2 className="font-serif text-lg md:text-xl text-white leading-tight">
                      {c.name}
                    </h2>
                    <p className="mt-0.5 text-[11px] md:text-xs text-white/75 line-clamp-1">
                      {c.tagline}
                    </p>
                    <span className="mt-2 inline-flex items-center gap-1.5 text-xs md:text-sm font-medium text-[#F4C8B8] opacity-0 translate-y-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0">
                      Ver cuadros
                      <ArrowRight className="h-3.5 w-3.5" />
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};
